import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { deleteOccupationArea } from "../../helper/API/occupation";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import { connect } from "react-redux";
import * as occupationAction from "../../redux/occupationList/action";

const DeleteModal = ({
  open,
  handleClose,
  data,
  setRefresh,
  refresh,
  occupationListData,
}) => {
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = () => {
    setLoading(true);
    const submitData = {
      id: data.id,
    };
    deleteOccupationArea(submitData).then((res) => {
      if (res.success) {
        handleClose();
        occupationListData();
        toast.success(res.message);
        setLoading(false);
      } else {
        toast.error(res.message);
        setLoading(false);
      }
    });
    // console.log("submitData", submitData);
  };
  return (
    <div>
      <Dialog fullWidth maxWidth={"sm"} open={open} onClose={handleClose}>
        <DialogTitle>Excluir ocupação</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Tem certeza de que deseja excluir a área de ocupação?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined" color="inherit">
            Não
          </Button>
          <Button
            onClick={handleSubmit}
            variant="outlined"
            color="error"
            sx={{ position: "relative" }}
            disabled={loading}
          >
            Sim
            {loading && (
              <CircularProgress
                size={24}
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                }}
              />
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
const mapDispatchToProp = (dispatch) => {
  return {
    occupationListData: () => dispatch(occupationAction.occupationList()),
  };
};

export default connect(null, mapDispatchToProp)(DeleteModal);
